<template>
  <div class="border-t border-primary-500 py-8">
    <div class="text-accent-900 font-semibold text-base mb-5">Danger zone</div>
    <div class="flex justify-between">
      <div class="space-y-1">
        <Label class="mb-0 text-neutral-300">Delete Role</Label>
        <p class="text-neutral-400 text-sm">
          Permanently delete this role from the workspace.
        </p>
      </div>
      <AlertDialog>
        <AlertDialogTrigger as-child>
          <Button variant="danger" type="button" size="sm"> Delete </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete Role</AlertDialogTitle>
          </AlertDialogHeader>
          <div class="px-7 space-y-4">
            <AlertDialogDescription>
              Are you sure you want to delete the
              <strong>{{ role.name }}</strong> role?
            </AlertDialogDescription>
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel as-child>
              <Button variant="ghost" :disabled="isPending">Cancel</Button>
            </AlertDialogCancel>
            <Button
              variant="danger"
              :disabled="isPending"
              :loading="isPending"
              @click="handleDelete"
            >
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@ui/components/alert-dialog';

import requests from '@vuex/requests.js';

import { Button } from '@ui/components/button';
import { queries } from '@/queries/index.js';
import { useStore } from 'vuex';
import { Label } from '@ui/components/label';

const props = defineProps({
  role: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const queryClient = useQueryClient();
const store = useStore();

const { isPending, mutate: deleteRole } = useMutation({
  mutationFn: () =>
    requests.roles.delete(store.getters['workspace/getId'], {
      id: props.role.id,
    }),
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: queries.workspace.roles.queryKey,
    });
    router.push({
      name: 'workspace-roles',
    });
  },
  onError: e => {
    console.log('error');
    console.log(e);
  },
});

const handleDelete = () => {
  deleteRole();
};
</script>
